module.exports = __webpack_public_path__ + "img/webcam-02.2e3bbd98.svg";